import { BaseService } from 'core/services';
import FacilityAreaOfCareRouteService from './FacilityAreaOfCareRouteService';

class FacilityAreaOfCareService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new FacilityAreaOfCareRouteService());
    }
}

export default FacilityAreaOfCareService;
